import { BottomAlignIcon, RightAlignIcon } from 'canoe';
import React, { useCallback } from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  alignItems?: string;
  alignSelf?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
  isChild?: boolean;
}

export const AlignFlexEnd = ({
  alignItems,
  alignSelf,
  flexDirection,
  toggleValues,
  isChild,
}: Props) => {
  const onClick = useCallback(() => {
    if (isChild) {
      toggleValues({
        alignSelf: 'flex-end',
      });
    } else {
      toggleValues({
        alignItems: 'flex-end',
      });
    }
  }, [isChild, toggleValues]);

  return (
    <ValueToggle
      toggleGroup={isChild ? 'self-align' : 'flex-align-items'}
      id={isChild ? 'self-align-flex-end' : 'align-flex-end'}
      data-cy="toolbox-flex-align-end"
      onClick={onClick}
      isActive={isChild ? alignSelf === 'flex-end' : alignItems === 'flex-end'}
      icon={flexDirection === 'row' ? BottomAlignIcon : RightAlignIcon}
      tooltip="End"
      color="light"
    />
  );
};
